import { Toast } from '@base-ui/react'

import { Snackbar } from './Snackbar'

export const List = () => {
	const { toasts } = Toast.useToastManager()

	return toasts.map((toast) => <Snackbar key={toast.id} toast={toast} />)
}
